export default {
  "pages.layouts.userLayout.title":
    "Ant Design is the most influential web design specification in Xihu district",
  "pages.login.accountLogin.tab": "Account Login",
  "pages.login.accountLogin.errorMessage":
    "Incorrect username/password(admin/ant.design)",
  "pages.login.failure": "Login failed, please try again!",
  "pages.login.success": "Login successful!",
  "pages.login.username.placeholder": "Username: admin or user",
  "pages.login.username.required": "Please input your username!",
  "pages.login.password.placeholder": "Password: ant.design",
  "pages.login.password.required": "Please input your password!",
  "pages.login.phoneLogin.tab": "Phone Login",
  "pages.login.phoneLogin.errorMessage": "Verification Code Error",
  "pages.login.phoneNumber.placeholder": "Phone Number",
  "pages.login.phoneNumber.required": "Please input your phone number!",
  "pages.login.phoneNumber.invalid": "Phone number is invalid!",
  "pages.login.captcha.placeholder": "Verification Code",
  "pages.login.captcha.required": "Please input verification code!",
  "pages.login.phoneLogin.getVerificationCode": "Get Code",
  "pages.getCaptchaSecondText": "sec(s)",
  "pages.login.rememberMe": "Remember me",
  "pages.login.forgotPassword": "Forgot Password ?",
  "pages.login.submit": "Login",
  "pages.login.loginWith": "Login with :",
  "pages.login.registerAccount": "Register Account",
  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage":
    "Faster and stronger heavy-duty components have been released.",
  "pages.404.subTitle": "Sorry, the page you visited does not exist.",
  "pages.404.buttonText": "Back Home",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.updateForm.ruleConfig": "Rule configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Information",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Please enter the rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Please enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Please enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Configure Properties",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Starting Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Please choose a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.searchTable.titleCallNo": "Number of Service Calls",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "default",
  "pages.searchTable.nameStatus.running": "running",
  "pages.searchTable.nameStatus.online": "online",
  "pages.searchTable.nameStatus.abnormal": "abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled at",
  "pages.searchTable.exception": "Please enter the reason for the exception!",
  "pages.searchTable.titleOption": "Option",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to alerts",
  "pages.searchTable.title": "Enquiry Form",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "chosen",
  "pages.searchTable.item": "item",
  "pages.searchTable.totalServiceCalls": "Total Number of Service Calls",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "batch deletion",
  "pages.searchTable.batchApproval": "batch approval",
  "pages.customerData.title": "Customer Data",
  "pages.customerData.dataName": "Data Name",
  "pages.customerData.dataType": "Chat Channel",
  "pages.customerData.createdAt": "Created At",
  "pages.customerData.createdBy": "Created By",
  "pages.customerData.updatedAt": "Updated At",
  "pages.customerData.updatedBy": "Updated By",
  "pages.customerData.dataList": "Data List",
  "pages.customerData.import.success": "Data imported successfully!",
  "pages.customerData.import.failure": "Data import failed!",
  "pages.customerData.import.error": "Data import error!",
  "pages.customerData.import.title": "Import Customer Data",
  "pages.customerData.update.title": "Update Customer Data",
  "pages.customerData.import": "Import Data",
  "pages.customerData.update": "Update Data",
  "pages.customerData.form.details": "Customer List Details",
  "pages.customerData.form.extraField": "Additional Fields",
  "pages.customerData.form.extraField.key": "Key",
  "pages.customerData.form.extraField.value": "Value",
  "pages.customerData.form.addDetail": "Add",
  "pages.customerData.form.addExtraField": "Add",
  "pages.customerData.form.deleteDetail": "Delete",
  "pages.customerData.form.deleteExtraField": "Delete",
  "pages.customerData.form.requirementField": "User ID",
  "pages.customerData.form.targetType": "Target Type",
  "pages.configInfoNoti.configName": "Data Name",
  "pages.configInfoNoti.configType": "Chat Channel",
  "pages.configInfoNoti.type": "Type",
  "pages.configInfoNoti.createdAt": "Created At",
  "pages.configInfoNoti.createdBy": "Created By",
  "pages.configInfoNoti.updatedAt": "Updated At",
  "pages.configInfoNoti.updatedBy": "Updated By",
  "pages.configInfoNoti.import": "Import Data",
  "pages.configInfoNoti.dataList": "Data List",
  "pages.configInfoNoti.import.success": "Data imported successfully!",
  "pages.configInfoNoti.import.failure": "Data import failed!",
  "pages.configInfoNoti.import.error": "Data import error!",
  "pages.configInfoNoti.import.title": "Import Data",
  "pages.configInfoNoti.update.title": "Update Data",
  "pages.configInfoNoti.update": "Update Data",
  "pages.configInfoNoti.update.success": "Data updated successfully!",
  "pages.configInfoNoti.form.details": "Config Chat Channel",
  "pages.configInfoNoti.form.extraField": "Additional Fields",
  "pages.configInfoNoti.form.extraField.key": "Key",
  "pages.configInfoNoti.form.extraField.value": "Value",
  "pages.configInfoNoti.form.addDetail": "Add",
  "pages.configInfoNoti.form.addExtraField": "Add",
  "pages.configInfoNoti.form.deleteDetail": "Delete",
  "pages.configInfoNoti.form.deleteExtraField": "Delete",
  "pages.campaignConfig.campaignName": "Campaign Name",
  "pages.campaignConfig.campaignType": "Chat Channel",
  "pages.campaignConfig.campaignStatus": "Status",
  "pages.campaignConfig.createdAt": "Created at",
  "pages.campaignConfig.createdBy": "Created by",
  "pages.campaignConfig.updatedAt": "Updated at",
  "pages.campaignConfig.updatedBy": "Updated by",
  "pages.campaignConfig.import": "Create Campaign",
  "pages.campaignConfig.dataList": "Data List",
  "pages.campaignConfig.import.success": "Data imported successfully!",
  "pages.campaignConfig.import.failure": "Data import failed!",
  "pages.campaignConfig.import.error": "Data import error!",
  "pages.campaignConfig.import.title": "Import Data",
  "pages.campaignConfig.update.title": "Update Data",
  "pages.campaignConfig.update": "Update Data",
  "pages.campaignConfig.form.details": "Config Chat Channel",
  "pages.campaignConfig.form.extraField": "Additional Fields",
  "pages.campaignConfig.form.extraField.key": "Key",
  "pages.campaignConfig.form.extraField.value": "Value",
  "pages.campaignConfig.form.addDetail": "Add",
  "pages.campaignConfig.form.addExtraField": "Add",
  "pages.campaignConfig.form.deleteDetail": "Delete",
  "pages.campaignConfig.form.deleteExtraField": "Delete",
  "pages.campaignConfig.form.configNotiId": "Notice",
  "pages.campaignConfig.form.customerDataId": "Customer Data",
  "pages.campaignConfig.form.startTime": "Start Time",
  "pages.campaignConfig.form.endTime": "End Time",
};
